/* Development urls */

// export const ERP_url = "/erp/api/erp";
// export const UPDASP_link = "https://updasp-demo.agrani.io";
// export const CMS_maati = "https://agrani-cms-dev.leadsconnect.in";
// export const Alaap_dev = "https://agrani-cms-dev.leadsconnect.in";


/* production urls */

export const ERP_url = "/erp-gateway/api";
export const UPDASP_link = "https://updasp.agrani.io";
export const CMS_maati = "https://cms-maati-prod.agrani.tech";
export const Alaap_dev = "https://agrani-cms.leadsconnect.in";

